<template>
  <caption>
    {{title}}
    <span class="col-vari-blue">{{ totalCount | setNumberCommas}}</span>
    <a href="#" @click.prevent="viewAllListFn()" class="btn-more search-view-all-r">
      <span>더보기</span>
      <i>더보기 아이콘</i>
    </a>
  </caption>
</template>

<script>
import { setNumberCommas } from '@/common/utils/common'
export default {
  name: 'SearchSupportListTitle',
  filters: {
    setNumberCommas
  },
  props: {
    title: {
      type: String
    },
    totalCount: {
      type: Number
    },
    viewAllListFn: {
      type: Function
    }
  }
}
</script>
